import React, { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './LogItem.css';
import { IonGrid, IonRow, IonCol, IonCard, IonIcon, IonItem, IonItemSliding, 
         IonItemOptions, IonItemOption, IonAlert, IonLoading } from '@ionic/react';
import { IActivityLogSearchResult } from '../domain/ActivityLog';
import { IClient } from '../domain/Client';

import ActivityLabel from './ActivityLabel';
import { eye, eyeOff, star, trash } from 'ionicons/icons';
import { formatListDates, formatDateForPopupItem } from '../services/utils';
import { DataAccessService } from '../services/dataAccessService';

interface LogItemProps extends RouteComponentProps{
    item : IActivityLogSearchResult,
    refresh: any
}
interface LogItemId {
    id : number
}

const LogItem: React.FC<LogItemProps> = ({ item, history, location, match, refresh }) => {
    const [viewed, setViewed] = useState(false);
    const [showPopupDelete, setShowPopupDelete] = useState<boolean>(false);
    const [messagePopupDelete] = useState('');
    const [showPopupClose, setShowPopupClose] = useState<boolean>(false);
    const [messagePopupClose] = useState('');
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [subHeaderMessage, setSubHeaderMessage] = useState('');
    const [loadingMessage, setLoadingMessage] = useState('');
    

    let _format24 = "0";
    if (window.localStorage.getItem("format2"))
        _format24 = String(window.localStorage.getItem("format24"));

    let _defaultClient = window.localStorage.getItem("defaultClient");
    let circleClass = "my_circle_" + item.ActivityLogEntryTypeID;
    let initials = "";
    let title = "";
    let dates = "";
    //let harbor = "";
    let my_gar_score = "";
    let isOpen = false; 
    let currentDate = new Date();

    if (!_defaultClient) {
        let _clients = JSON.parse(String(window.localStorage.getItem("clients"))) as IClient[];
        if (_clients && _clients.length > 0) {
            // eslint-disable-next-line eqeqeq
            let _clientItem = _clients.find((x) => x.ClientID.toString() == item.ClientID);
            if (_clientItem) {
                //harbor = _clientItem.ClientName;
            }
        }
    }

    switch (item.ActivityLogEntryTypeID) {
        case 1:
            initials = "NT";
            title = item.ActivityType;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, true);
            break;
        case 2:
            initials = "TL";
            title = item.ActivityType;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, true);
            break;
        case 3:
            initials = "IN";
            title = item.Category;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, true);
            break;
        case 4:
            initials = "EQ";
            title = item.EquipmentTitle;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, true);
            break;
        case 5:
            initials = "PO";
            title = item.PumpoutTitle;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, false);
            break;
        case 6:
            initials = "VI";
            title = item.ViolationTitle;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, false);
            break;
        case 7:
            initials = "CO";
            title = item.ConditionTitle;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, false);
            break;
        case 8:
            initials = "SC";
            title = item.SafetyCheckTitle;
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, false);
            break;
        case 9:
            initials = "GS";
            title = "GAR #" + item.ActivityLogID.toString();
            dates = formatListDates(item.DateStarting, item.DateEnding, _format24, false);
            if (item.GARTotal < 24)
                my_gar_score = 'my-gar-score-green';
            else if (item.GARTotal < 45)
                my_gar_score = 'my-gar-score-yellow';
            else
                my_gar_score = 'my-gar-score-red'
            break;
        default:
            break;       
    }

    if ([1,2,3,4].includes(item.ActivityLogEntryTypeID) && !item.DateEnding){
        isOpen=true;
    }

    useEffect(() => {
        let storageViewedActivities = window.localStorage.getItem("viewedActivities");
        if (storageViewedActivities) { 
            let myViewedActivities = JSON.parse(storageViewedActivities) as LogItemId[];
            let found = myViewedActivities.filter((x:LogItemId) => x.id === item.ActivityLogID);
            if (found.length > 0) {
                setViewed(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const cardClick = () => { 
        if (!viewed) {
            let storageViewedActivities = window.localStorage.getItem("viewedActivities");
            let myViewedActivities: LogItemId[] = [];
            if (storageViewedActivities){
                myViewedActivities = JSON.parse(storageViewedActivities) as LogItemId[];
            }
            myViewedActivities = [...myViewedActivities, {'id':item.ActivityLogID}];
            window.localStorage.setItem("viewedActivities", JSON.stringify(myViewedActivities)); 
        }
        if (isOpen) {
            currentDate = new Date();
            setSubHeaderMessage('Your end date will be ' + formatDateForPopupItem(currentDate, _format24));
            setLoadingMessage('Closing ...')
            setShowPopupClose(true);  
        }
        else {
            history.push('/activity/' 
                    + item.ActivityLogID.toString() 
                    + '/' + item.ClientID.toString() 
                    + '/' + item.ActivityLogEntryTypeID.toString() 
                    + '/0/0/0/0/0');
        }
    }

    const deleteItem = () => {
        setShowPopupDelete(false);
        setShowLoading(true);
        if (window.localStorage.getItem("token") && window.localStorage.getItem("expireTokenDate")) {
            let storedToken = String(window.localStorage.getItem("token"));
            let expireTokenDate = new Date(String(window.localStorage.getItem("expireTokenDate")));
            if (expireTokenDate > new Date()) {
                new DataAccessService().deleteActivityLog(storedToken, item.ActivityLogID.toString()) 
                .then(function (expectedData) {
                    setShowLoading(false);
                    refresh(item.ActivityLogID);
                },
                function (reason) {
                    setShowLoading(false);
                    refresh(0);
                });   
            }
            else {
                setShowLoading(false);
                history.push("/login");
            }
        }
        else {
            setShowLoading(false);
            history.push("/login");
        }
    }

    const closeItem = () => {
        setShowPopupDelete(false);
        setShowLoading(true);
        if (window.localStorage.getItem("token") && window.localStorage.getItem("expireTokenDate")) {
            let storedToken = String(window.localStorage.getItem("token"));
            let expireTokenDate = new Date(String(window.localStorage.getItem("expireTokenDate")));
            if (expireTokenDate > new Date()) {
                new DataAccessService().updateActivityLog(storedToken, item.ActivityLogID.toString(), currentDate.toISOString()) 
                .then(function (expectedData) {
                    setShowLoading(false);
                    refresh(item.ActivityLogID, false);
                },
                function (reason) {
                    setShowLoading(false);
                    refresh(0);
                });   
            }
            else {
                setShowLoading(false);
                history.push("/login");
            }
        }
        else {
            setShowLoading(false);
            history.push("/login");
        }
    }

    const slide = (_item:any) => {
        setLoadingMessage('Deleting...');
        setShowPopupDelete(true);
    }

    return (
        <>
            <IonItemSliding>
                <IonItem lines="none" className="my_ionItemS">
                    <IonCard mode="ios" className="my_card" onClick={cardClick} key={item.ActivityLogID}>
                        <IonGrid className="my_grid">
                            <IonRow>
                                <IonCol size="2">
                                    <div className={circleClass}>
                                        { (item.Pinned) 
                                            ? <IonIcon mode="ios" className="my_starItem" icon={star}></IonIcon>
                                            : <span className="my_circleLabel">{initials}</span>}
                                    </div>
                                </IonCol>
                                <IonCol>
                                    <div className="my_content">
                                        {item.GARTotal !== 0 &&
                                            <>
                                                <span className="my_title">{title}</span> <span className={my_gar_score}>{item.GARTotal}</span><br/>
                                            </>
                                        }
                                        {item.GARTotal === 0 &&
                                            <>
                                                <span className="my_title">{title}</span><br/>
                                            </>
                                        }
                                        <span className="my_dates">{dates}</span><br/>
                                        {/* <span className="my_harbor">{harbor} </span> */}
                                        {window.localStorage.getItem("username") !== item.LoginID &&
                                            <span className="my_harbor">{item.LoginID}</span>
                                        }
                                    </div>
                                </IonCol>
                                <IonCol size="3">
                                    <IonIcon mode="ios" className="my_icon" icon={viewed ? eye : eyeOff} size="smaller"></IonIcon> <br/>
                                    <ActivityLabel activityTypeId={item.ActivityLogEntryTypeID}></ActivityLabel>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonCard>
                 </IonItem>
                 <IonItemOptions>
                    <IonItemOption color="danger" onClick={(_item) => slide(_item)}>
                         <IonIcon slot="top" icon={trash}/><br/>
                         Delete
                     </IonItemOption>
                 </IonItemOptions>
             </IonItemSliding>

            <IonAlert mode="ios"
                isOpen={showPopupDelete}
                onDidDismiss={() => setShowPopupDelete(false)}
                cssClass='my-alert'
                header={'Warning'}
                subHeader={'Are you sure you want to delete this entry?'}
                message={messagePopupDelete}
                buttons={[
                     {
                        text: 'No, go to edit',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            history.push('/activity/' + item.ActivityLogID.toString() 
                                                    + '/' + item.ClientID.toString() 
                                                    + '/' + item.ActivityLogEntryTypeID.toString() 
                                                    + '/0/0/0/0/0');
                        }
                     },
                     {
                        text: 'Yes',
                        handler: () => {
                            deleteItem()
                        }
                     }
                 ]}
            /> 
            <IonAlert mode="ios"
                isOpen={showPopupClose}
                onDidDismiss={() => setShowPopupClose(false)}
                cssClass='my-alert'
                header={'What would you like to do?'}
                subHeader={subHeaderMessage}
                message={messagePopupClose}
                buttons={[
                     {
                        text: 'Edit',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            history.push('/activity/' + item.ActivityLogID.toString() 
                                                    + '/' + item.ClientID.toString() 
                                                    + '/' + item.ActivityLogEntryTypeID.toString()
                                                    + '/0/0/0/0/0');
                        }
                     },
                     {
                        text: 'Close',
                        handler: () => {
                            closeItem();
                        }
                     }
                 ]}
            /> 
            <IonLoading mode="ios"
                cssClass='my-loading'
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={loadingMessage}
            />
         </>
    )
};

export default LogItem;